const SvgIcon = ({ size = '24', color = '#e8eaed' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    version="1.1"
    viewBox="0 -960 960 960"
  >
    <path
      id="path845"
      strokeWidth="1"
      d="M0-160v-106.667h320V-160Zm0-266.667v-106.666h640v106.666zm0-266.666V-800h960v106.667z"
    ></path>
  </svg>
);

export default SvgIcon;
